/* eslint no-unused-vars: ["error", { "varsIgnorePattern": "magnificPopup" }] */

// -----------------------------------------------------------------------------
// Component Includes
// -----------------------------------------------------------------------------
// Need to import Magnific Popup once for it to be available to components
import magnificPopup from 'magnific-popup';

import extendJquery from '@plugins/extend-jquery';
import facetWpAccessibility from '@plugins/facetwp-accessibility';
import images from '@plugins/images';
import loading from '@plugins/loading';
import accordion from '@components/accordion';
import contactFormModal from '@components/modal/contact-form-modal';
import contentSlider from '@components/content-slider';
import leadership from '@components/leadership';
import socialShare from '@components/social-share';
import stat from '@components/stat';
import videoModal from '@components/modal/video-modal';
import EmailSignup from '@components/email-signup';
import ReadMore from '@components/read-more';
import Search from '@components/search';
import SiteHeader from '@components/site-header';
import StickyNav from '@components/sticky-nav';
import formValidation from '@plugins/form-validation';
import anchorSmoothScroll from '@plugins/anchor-smooth-scroll';
import aauwFormFields from '@plugins/aauw-form-field';
import autosize from '@plugins/autosize';
import jsLinkEvent from '@plugins/js-link-event';
import gravityForms from '@plugins/gravity-forms';
import PopupManagement from '@plugins/aauw-popup-management';

(($) => {

  // Document Ready
  $(() => {

    // -----------------
    // High-priority JS
    // -----------------
    extendJquery();
    images();
    loading();
    if (document.querySelector('.facetwp-facet')) {
      facetWpAccessibility();
    }
    contentSlider();

    // -----------------
    // Low-priority JS
    // -----------------
    new SiteHeader();
    if (document.getElementById('sticky-nav')) {
      new StickyNav();
    }
    new EmailSignup();
    accordion();
    leadership();
    if (document.getElementById('search-page')) {
      new Search();
    }
    stat();
    formValidation();
    anchorSmoothScroll();
    aauwFormFields();
    contactFormModal();
    videoModal();
    if (document.querySelector('.read-more-wrapper')) {
      new ReadMore();
    }
    jsLinkEvent();
    gravityForms();
    autosize();
    socialShare();
    new PopupManagement();

  });

})($);
